import { jsx as _jsx } from "react/jsx-runtime";
import { useEvent } from '@/hooks/useEvent';
import clsx from 'clsx';
import { FocusScope, usePreventScroll } from 'react-aria';
import { createPortal } from 'react-dom';
import { applyTheme } from '../../../utils/themeUtils';
const Dialog = ({ className, children, onDismiss, ariaLabel, theme, ...props }) => {
    usePreventScroll();
    useEvent('keydown', (event) => {
        if (event.key === 'Escape') {
            onDismiss();
        }
    });
    const target = typeof document !== 'undefined' ? document.body : null;
    if (!target) {
        return null;
    }
    return createPortal(_jsx("dialog", { className: clsx('z-(--z-dialog)', applyTheme(theme), className), "aria-label": ariaLabel, ...props, children: _jsx(FocusScope, { autoFocus: true, contain: true, restoreFocus: true, children: children }) }), target);
};
export default Dialog;
